import React, { useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

import InfoBox from "../layout/InfoBox";

const CheckBoxGroup = ({ label, options, value, sx, onChange }) => {
  const theme = useTheme();

  const handleChange = (id) => {
    let newValue = [];
    if (value) newValue = [...value];

    let index = newValue.findIndex((value) => value === id);

    if (index === -1) {
      newValue.push(id);
    } else {
      newValue.splice(index, 1);
    }

    onChange(newValue);
  };

  return (
    <InfoBox
      label={label}
      sx={sx}
    >
      <Stack>
        {Array.isArray(options) && options.length > 0
          ? options.map((option) => (
              <Box
                sx={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange(option.id)}
              >
                {value?.includes(option.id) ? (
                  <CheckBoxIcon color="primary" />
                ) : (
                  <CheckBoxOutlineBlankIcon color="primary" />
                )}
                <Typography sx={{ fontSize: "12px" }}>{option.name}</Typography>
              </Box>
            ))
          : null}
      </Stack>
    </InfoBox>
  );
};

export default CheckBoxGroup;
